module.exports = __webpack_public_path__ + "61e792fb0d0d28e28e63930760e4be22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/v/v27.jpg
// module id = 775
// module chunks = 0